// Pure helpers for the calendar-v2 table rows. Kept visually identical to the
// legacy economic-calendar-table so ported classifications read as one system.
// (Presentational components live in ./presentational to satisfy react-refresh.)

export const getArrowAndColor = (
  act: string | number | null | undefined,
  exp: string | number | null | undefined
) => {
  const actValue = parseFloat(String(act));
  const expValue = parseFloat(String(exp));

  if (!isNaN(actValue) && !isNaN(expValue)) {
    if (actValue > expValue) return { color: "text-green-500", arrow: "▲" };
    if (actValue < expValue) return { color: "text-red-500", arrow: "▼" };
  }
  return { color: "text-gray-500 dark:text-gray-300", arrow: "" };
};

export const formatValueWithUnit = (
  value: string | number | null | undefined,
  unit?: string | null
) => {
  if (value === null || value === undefined || value === "") return null;
  if (!unit) return value;
  return `${value}${unit}`;
};

/** Compact numeric formatter for earnings/supply figures (K/M/B). */
export const formatNumber = (
  value: number | null | undefined,
  opts: { currency?: string | null; compact?: boolean } = {}
): string | null => {
  if (value === null || value === undefined || isNaN(value)) return null;
  const abs = Math.abs(value);
  let out: string;
  if (opts.compact && abs >= 1_000) {
    if (abs >= 1_000_000_000) out = `${(value / 1_000_000_000).toFixed(2)}B`;
    else if (abs >= 1_000_000) out = `${(value / 1_000_000).toFixed(2)}M`;
    else out = `${(value / 1_000).toFixed(2)}K`;
  } else {
    out = String(value);
  }
  return opts.currency ? `${opts.currency} ${out}` : out;
};

export const isEventInPast = (eventDate: string): boolean =>
  new Date(eventDate).getTime() < new Date().getTime();
